<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Alerts</li>
  </app-tabs>
  <app-alert-templates class="flex-control flex-column" [hidden]="tabs_service.is_active()"></app-alert-templates>
</div>
